export default "__VITE_ASSET__BZZmp7ty__"